/*
    axios 请求封装
*/
import axios from "axios";
import qs from "qs";
import sha1 from "crypto-js/sha1";
import de from "element-ui/src/locale/lang/de";

// headers 信息
const appKey = process.env.VUE_APP_APP_KEY;
const appSecret = process.env.VUE_APP_APP_SECRET;

// const appKey = 'inneruser';
// const appSecret = '1234567inner';

const request = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    withCredentials: false, //跨域请求是否需要凭证
    timeout: 10000,
});
export function createNonceStr(length) {
    let chars =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let str = "";
    for (let i = 0; i < length; i++) {
        str += chars.substr(parseInt(Math.random() * chars.length), 1);
    }
    return str;
}
//请求拦截器
request.interceptors.request.use(
    //请求前验证
    (config) => {
        if (sessionStorage.getItem("token")) {
            config.headers = { token: sessionStorage.getItem("token") };
        }

        if(sessionStorage.getItem("appid")) {
            config.headers.appid = sessionStorage.getItem("appid");
        }
        if(sessionStorage.getItem("enterid")) {
            config.headers.enterid = sessionStorage.getItem("enterid");
        }
        if(sessionStorage.getItem("k")) {
            config.headers.k = sessionStorage.getItem("k");
        }
        return config;
    },
    //请求错误处理
    (error) => {
        return Promise.reject(error);
    }
);

//响应拦截器
request.interceptors.response.use(
    (response) => {
        const res = response.data;
        //请求成功
        if (res.ret !== 200) {
            if (res.ret == 99999 && res.msg.indexOf("Expired token") != -1) {
                alert("TOKEN失效，请关闭并重新进入会话窗口");
                return res.data;
            } else {
                return Promise.reject(res.msg);
            }
        } else {
            return res.data;
        }
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default request;
